import { signOut } from '@aws-amplify/auth';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { LocalStorageKeys } from '@/modules/common';
import { useCurrentUser } from '@/modules/common/store';
import { Routes } from '@/router/routes';

export function useLogout() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { setCurrentUser } = useCurrentUser();

  const logoutUser = async () => {
    try {
      await signOut();
      localStorage.removeItem(LocalStorageKeys.AccessToken);
      setCurrentUser(null);
      navigate(Routes.SignIn);
      queryClient.clear();
    } catch (error) {
      toast.error(error.message);
    }
  };

  return logoutUser;
}
